import moment from "moment";

import HandBookTemplateApprovingCell from "pages/HandBook/features/HandBookTemplateApprovingCell/HandBookTemplateApprovingCell";
import TemplateDownloadButton from "pages/HandBook/features/TemplateDownloadButton/TemplateDownloadButton";
import { IHandBookTemplate } from "pages/HandBook/model/types";
import HandBookApplyToObject from "pages/HandBook/widgets/HandBookApplyToObject/HandBookApplyToObject";

import { ICommonColumn } from "./HandBooksTemplates";
import { useTypedSelector } from "app/store/typedUseSelector";

import { VIEW_HANDBOOK_APPROVALS } from "constants/permissions/generalPermissions";

import usePermission from "hooks/usePermission";

import { fullNameToShortName } from "utils/formatters/getShortFullName";

export const useHandbookTemplatesColumns = () => {
  const hasHandbookApprovalPermission = usePermission(VIEW_HANDBOOK_APPROVALS);
  const isEditing = useTypedSelector((state) => state.handBookReducer.templateEditings.isEditing);

  const colPercents = hasHandbookApprovalPermission ? [63, 2, 12, 10, 10] : [75, 2, 10, 10];
  const baseCols: ICommonColumn<IHandBookTemplate>[] = [
    { header: { title: "Шаблон", filterName: "name" }, render: (item) => item.name },
    {
      header: { title: "" },
      render: (item) => (
        <>
          <HandBookApplyToObject template={item} />
          <TemplateDownloadButton templateId={item.id} templateName={item.name} />
        </>
      ),
      isCentered: true, 
    },
    {
      header: {
        title: "Дата",
        filterName: "created_at",
        filterType: "datesRange",
        rangeStartField: "created_at_after",
        rangeEndField: "created_at_before",
      },
      render: (item) => moment(item.created_at).format("DD.MM.YYYY"),
      isCentered: true,
    },
    {
      header: { title: "Автор", filterName: "author" },
      render: (item) => fullNameToShortName(item.author?.full_name || ""),
      isNoBreak: true,
    },
  ];

  const columns = hasHandbookApprovalPermission
    ? baseCols.concat([
        {
          header: { title: "Согласование" },
          render: (item) => <HandBookTemplateApprovingCell templateId={item.id} approvals={item.approval_steps} />,
          isCentered: true,
        },
      ])
    : baseCols;
  return { columns, colPercents: isEditing ? [3, colPercents[0] - 3, ...colPercents.slice(1)] : colPercents };
};
